import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IPhoneMessage, PhoneMessage } from "@/models/phone-message.entity";

export const PhoneMessageDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IPhoneMessage> {
  getIdentifier(entity: IPhoneMessage): string {
    return entity.id;
  }

  mapEntity(entity: IPhoneMessage): IPhoneMessage {
    return new PhoneMessage(entity);
  }
})();
